import { motion } from "framer-motion";
import { ShieldCheck, Award } from "lucide-react";

export function TrustBanner() {
	const badges = [
		{ icon: ShieldCheck, title: "100% Admission Assurance*", desc: "We link our success directly to your intake metrics." },
		{ icon: Award, title: "50 Admissions Assured for Preschool Launch*", desc: "Launch with a full nursery batch on day one." },
	];
	return (
		<section className="py-14 bg-gradient-to-br from-emerald-700 to-teal-800">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="text-center mb-10">
					<h2 className="font-heading text-2xl sm:text-3xl font-bold text-white">
						Backed by Unmatched Growth Commitments
					</h2>
				</div>
				<div className="grid gap-5 md:grid-cols-2">
					{badges.map((b, i) => (
						<motion.div key={b.title}
							initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
							transition={{ delay: i * 0.1 }}
							className="flex items-start gap-4 rounded-2xl bg-white/10 backdrop-blur-sm border border-white/15 p-6"
						>
							<span className="grid place-items-center h-12 w-12 rounded-xl bg-white/15 text-amber-300 shrink-0">
								<b.icon className="h-6 w-6" />
							</span>
							<div>
								<h3 className="font-heading text-lg font-bold text-white">{b.title}</h3>
								<p className="mt-1 text-sm text-emerald-50/90">{b.desc}</p>
							</div>
						</motion.div>
					))}
				</div>
				<p className="mt-6 text-center text-xs text-emerald-100/70">
					*Subject to eligibility criteria and engagement scope. Discussed during your consultation.
				</p>
			</div>
		</section>
	);
}
